import React from "react"
import type { FC } from "react"

import { HStack } from "@/nzds/layout"
import type { HStackProps } from "@/nzds/layout"
import { useFlags } from "@/services/feature"

import Skeleton from "@mui/material/Skeleton"
import { styled } from "@mui/material/styles"

import { ReportingCard } from "../reportingCard/reportingCard"
import type { ReportingCardsProps } from "./reporting-cards.types"

const ReportingCardsRoot = styled(HStack)<HStackProps<"div">>(({ theme }) => ({
  flexWrap: "wrap",
  gap: theme.spacing(3),
  marginBottom: theme.spacing(3),
}))

export const ReportingCards: FC<ReportingCardsProps> = ({
  cards,
  isLoading,
}) => {
  const flags = useFlags()

  return (
    <ReportingCardsRoot>
      {isLoading
        ? cards.map((card) => (
            <Skeleton
              data-testid={card.title}
              key={card.title}
              height={160}
              variant="rounded"
              width={320}
            />
          ))
        : cards
            .filter((card) => {
              return card.featureFlag === undefined || flags[card.featureFlag]
            })
            .map((card) => <ReportingCard key={card.title} card={card} />)}
    </ReportingCardsRoot>
  )
}
